import {ArticleDto, IArticlesWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, Router} from "@angular/router";

@Injectable()
export class GestionArticlesResolver implements Resolve<Array<ArticleDto>> {

  constructor(private articleWebService: IArticlesWebServiceClient, private router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot) {
    let categorieId: number = Number(route.paramMap.get('id'));
    return this.articleWebService.rechercheArticles(categorieId);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-commande-materiel/digicerba-commande-materiel-web/src/angular/cerba/src/app/pages/cerba/pages/categories/gestion-articles/gestion.articles.resolver.ts